module.exports = __webpack_public_path__ + "dist/img/fengxingzhong.c046917.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content/fengxingzhong.png
// module id = qGzX
// module chunks = 1